import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import PropTypes from 'prop-types';

import {
    DownloadFileGeneric,
    FormElems,
    Popup,
    Table,
    TableFilter,
    ViewDownloadGeneric,
} from '../../components';
import PaymentGatewayCredentialsActions from './PaymentGatewayCredentialsActions';

import {
    clickedCreatePaymentCredentialData,
    downloadPaymentGatewayCredentialReportRequest,
    fetchPayementGatewayCredentialsRequest,
    generatePaymentGatewayCredentialReportError,
    generatePaymentGatewayCredentialReportRequest,
    getActivePaymentGatewayCredentialReportRequest,
} from './redux/paymentGatewayCredentials.actions';

import { PAYMENT_GATEWAY_OPTION } from './constants';
import { PAYMENT_MODE, REPORT_TYPE_ENUM } from 'utils/constants/commonValues';

import './paymentGatewayCredentialsPage.scss';


let filterFieldList = [
    // {
    //     fieldType: 'date',
    //     label: 'Date Range',
    //     name: 'createdOn',
    //     props: {
    //         startDate: moment()
    //             .endOf('day')
    //             .subtract(730, 'days'),
    //         endDate: moment().endOf('day'),
    //         maximumNights: 365,
    //         notResetDate: true,
    //     },
    // },
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment().endOf('day').subtract(1, 'months'),
            endDate: moment().endOf('day'),
            maximumNights: 31,
            notResetDate: true,
        },
    },
    // {
    //     fieldType: 'date',
    //     label: 'Date Range',
    //     name: 'createdOn',
    //     props: {
    //         startDate: null,
    //         endDate: null,
    //         maximumNights: 31,
    //         notResetDate: true,
    //     },
    // },
    {
        fieldType: 'search-select',
        label: 'Category',
        name: 'category',
        props: {
            data: [],
            label: 'Select on Category',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'search-select',
        label: 'MCC',
        name: 'mcc',
        props: {
            data: [],
            label: 'Select on MCC',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'search-select',
        label: 'PG',
        name: 'pgName',
        props: {
            data: PAYMENT_GATEWAY_OPTION,
            label: 'Select on PG',
            labelField: 'name',
            valueField: 'value',
        },
    },
    {
        fieldType: 'search-select',
        label: 'Payment Mode',
        name: 'paymentMode',
        props: {
            data: PAYMENT_MODE,
            label: 'Select on Payment Mode',
            labelField: 'label',
            valueField: 'value',
        },
    },
    {
        fieldType: 'input',
        label: 'Credential ID',
        name: 'credentialId',
        props: {
            placeholder: 'Enter Credential ID',
        },
    },
];
const pageSizeOptions = [50, 40, 20, 10, 60];

const PaymentGatewayCredentialsPage = ({
    paymentGatewayCredentialsData,
    dispatch,
    actions,
    loader: { showLoader },
    staticData
}) => {
    const history = useHistory();
    console.log("action and dispatch", actions, dispatch);
    const {
        error,
        tableData,
        isLoading,
        pagination,
        generatedFile,
        activeReports,
    } = paymentGatewayCredentialsData;

    const columns = useMemo(
        () => [
            { header: 'PG Name', accessor: 'pgName' },
            { header: 'Merchant Code', accessor: 'credentialId' },
            { header: 'Category', accessor: 'category' },
            { header: 'MCC', accessor: 'mcc' },
            { header: 'Status', accessor: 'status' },
            { header: 'Last Update Date', accessor: 'lastUpdatedDate' },
            { header: 'Last Updated By', accessor: 'lastUpdatedBy' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const [isResetPage, setIsResetPage] = useState(false);
    const [filterData, setFilterData] = useState({});

    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const [showViewDownloadList, setViewDownloadList] = useState(false);

    const handleViewDownloads = () => setViewDownloadList(true);
    const handleCloseViewDownloads = () => setViewDownloadList(false);

    const handleCreateCredentails = () => {
        actions.clickedCreatePaymentCredentialData();
        history.push('/payment-gateway-credentials/create/credentials');
    }


    const handleCategoryFilterChange = category => {
        if (
            staticData &&
            staticData.staticInfo &&
            staticData.staticInfo.categoryMap &&
            category
        ) {
            const categoryDetails = staticData.staticInfo.categoryMap.find(
                item => item.name.toLowerCase() === category.toLowerCase()
            );
            
            // fetch MCC codes for the selected category
            const options =
                categoryDetails && categoryDetails.options
                .map(item => item.mcc.map(code => ({ name: code, value: code })))
                .reduce((acc, curr) => acc.concat(curr), [])

            filterFieldList = filterFieldList.map(filter => {
                if (filter.name === 'mcc') {
                    filter.props = {
                        ...filter.props,
                        data: options || [],
                    };
                }
                return filter;
            });
        }
    };

    useEffect(() => {
        if (generatedFile.isSuccess) {
            setViewDownloadList(true);
            setShowDownloadPopup(false);
        }
        return () => {
            // actions.generatePaymentGatewayCredentialReportError({ error: {} });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generatedFile.isSuccess]);

    useEffect(() => {
        if (
            staticData &&
            staticData.staticInfo &&
            staticData.staticInfo.categoryMap
        ) {
            filterFieldList = filterFieldList.map(filter => {
                if (filter.name === 'category') {
                    filter.props = {
                        data: staticData.staticInfo.categoryMap,
                        label: 'Select on Category',
                        labelField: 'name',
                        valueField: 'value',
                        onChange: handleCategoryFilterChange,
                    };
                }
                return filter;
            });
        }
    }, [staticData, handleCategoryFilterChange]);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageIndex,
            };
            if (
                filterData.createdOn &&
                Object.keys(filterData.createdOn).length
            ) {
                actions.fetchPayementGatewayCredentialsRequest({
                    ...data,
                    ...filterData,
                });
            }
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    return (
        <div className="payment-gateway-credenials-table-wrapper">
            <Table
                tableTitle="PG Credentials Repository"
                filterActionTitle="View Downloads"
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                onClickTableAction={handleViewDownloads}
                isPGRepoTab={true}
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        fieldsList={filterFieldList}
                        onSubmit={filterValues => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...filterValues,
                            });
                            setIsResetPage(true);
                        }}
                        onReset={resetValue => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...resetValue,
                            });
                            setIsResetPage(true);
                        }}
                    />
                }
                additionalActions={() => {
                    return (
                        <>
                            <DownloadFileGeneric
                                filterData={filterData}
                                tableData={tableData}
                                reportType={REPORT_TYPE_ENUM.PG_MID_REPORT}
                                generateReportRequest={
                                    actions.generatePaymentGatewayCredentialReportRequest
                                }
                                showDownloadPopup={showDownloadPopup}
                                setShowDownloadPopup={setShowDownloadPopup}
                                generateData={generatedFile}
                            />
                            <div className="button-container pg-credentials">
                                <button
                                    className="custom-btn"
                                    id="next-btn"
                                    type="button"
                                    onClick={handleCreateCredentails}
                                >
                                    CREATE CREDENTIALS
                                </button>
                            </div>
                        </>
                    );
                }}
                tableActionPopup={
                    <Popup
                        title="Download Status"
                        showCloseIcon
                        showOverlay
                        showFilter={showViewDownloadList}
                        closePopup={handleCloseViewDownloads}
                    >
                        <ViewDownloadGeneric
                            data={activeReports.reports}
                            downloadReportRequest={
                                actions.downloadPaymentGatewayCredentialReportRequest
                            }
                            getActiveReportRequest={
                                actions.getActivePaymentGatewayCredentialReportRequest
                            }
                        />
                    </Popup>
                }
                userActions={data => (
                    <PaymentGatewayCredentialsActions
                        data={data}
                        history={history}
                    />
                )}
            />
        </div>
    );
};

PaymentGatewayCredentialsPage.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    paymentGatewayCredentialsData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
};

const mapStateToProps = ({
    auth,
    paymentGatewayCredentialsData,
    loader,
    staticData,
}) => ({
    auth,
    paymentGatewayCredentialsData,
    loader,
    staticData,
});

const mapDispatchToProps = dispatch => ({

    actions:
        bindActionCreators(
            {
                fetchPayementGatewayCredentialsRequest,
                generatePaymentGatewayCredentialReportRequest,
                getActivePaymentGatewayCredentialReportRequest,
                downloadPaymentGatewayCredentialReportRequest,
                generatePaymentGatewayCredentialReportError,
                clickedCreatePaymentCredentialData

            },
            dispatch
        ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentGatewayCredentialsPage);
